import { JsonObject } from 'json2typescript';
import { UserDataResponseInterface } from '../interfaces/userdata-response.interface';

@JsonObject('UserDataResponseModel')
export class UserDataResponseModel implements UserDataResponseInterface {
  Email?: string;
  FullName?: string;
  Id?: string;
  Phone?: string;
}
